export const supplierTableTemplate = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'company_name',
    description: 'Razão social',
    originalId: 'company_name',
    width: 300,
  },
  {
    id: 'company_trade_name',
    description: 'Nome fantasia',
    originalId: 'company_trade_name',
    width: 300,
  },
  {
    id: 'document_number',
    description: 'CPF/CNPJ',
    originalId: 'document_number',
    width: 200,
  },
  {
    id: 'category',
    description: 'Categoria',
    originalId: 'category',
    width: 220,
  },
  {
    id: 'email',
    description: 'E-mail',
    originalId: 'email',
    width: 300,
  },
  {
    id: 'phone',
    description: 'Telefone',
    originalId: 'phone',
    width: 200,
  },
  {
    id: 'formattedStreet',
    description: 'Rua',
    originalId: 'formattedStreet',
    width: 200,
  },
  {
    id: 'formattedCity',
    description: 'Cidade',
    originalId: 'formattedCity',
    width: 200,
  },
  {
    id: 'formattedState',
    description: 'UF',
    originalId: 'formattedState',
    width: 200,
  },
  {
    id: 'formattedActive',
    description: 'Ativo',
    originalId: 'formattedActive',
    width: 200,
  },
  {
    id: 'formattedCreatedAt',
    description: 'Data de Registro',
    originalId: 'created_at',
    width: 200,
  },
];
